import { BaseAPIRequestFactory, RequiredError } from './baseapi.js';
import { HttpMethod, HttpInfo } from '../http/http.js';
import { ObjectSerializer } from '../models/ObjectSerializer.js';
import { ApiException } from './exception.js';
import { isCodeInRange } from '../util.js';
async function deserializeResponseBody(response, dataType, dataFormat) {
    return ObjectSerializer.deserialize(await response.body.json(), dataType, dataFormat);
}
async function deserializeErrorBodyOrFallback(response, dataType, dataFormat) {
    try {
        return await deserializeResponseBody(response, dataType, dataFormat);
    }
    catch {
        return await response.getBodyAsAny();
    }
}
export class AccountsApiRequestFactory extends BaseAPIRequestFactory {
    async activateAtlasOrganization(projectId, id, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "activateAtlasOrganization", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("AccountsApi", "activateAtlasOrganization", "id");
        }
        const localVarPath = '/v1/projects/{projectId}/atlas-organizations/{id}/activate'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PATCH, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async activateAzureManagementGroup(projectId, id, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "activateAzureManagementGroup", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("AccountsApi", "activateAzureManagementGroup", "id");
        }
        const localVarPath = '/v1/projects/{projectId}/azure-management-groups/{id}/activate'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PATCH, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async activateGcpFolder(projectId, id, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "activateGcpFolder", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("AccountsApi", "activateGcpFolder", "id");
        }
        const localVarPath = '/v1/projects/{projectId}/gcp-folders/{id}/activate'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PATCH, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async activateGcpOrganization(projectId, id, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "activateGcpOrganization", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("AccountsApi", "activateGcpOrganization", "id");
        }
        const localVarPath = '/v1/projects/{projectId}/gcp-organizations/{id}/activate'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PATCH, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async activateGcpRestoreFolder(projectId, id, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "activateGcpRestoreFolder", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("AccountsApi", "activateGcpRestoreFolder", "id");
        }
        const localVarPath = '/v1/projects/{projectId}/gcp-restore-folders/{id}/activate'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PATCH, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async activateGcpRestoreOrganization(projectId, id, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "activateGcpRestoreOrganization", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("AccountsApi", "activateGcpRestoreOrganization", "id");
        }
        const localVarPath = '/v1/projects/{projectId}/gcp-restore-organizations/{id}/activate'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PATCH, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async connectAtlasOrganization(projectId, connectAtlasOrganizationRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "connectAtlasOrganization", "projectId");
        }
        if (connectAtlasOrganizationRequest === null || connectAtlasOrganizationRequest === undefined) {
            throw new RequiredError("AccountsApi", "connectAtlasOrganization", "connectAtlasOrganizationRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/atlas-organizations'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(connectAtlasOrganizationRequest, "ConnectAtlasOrganizationRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async connectCustomerVaultAccount(connectCustomerVaultAccountRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (connectCustomerVaultAccountRequest === null || connectCustomerVaultAccountRequest === undefined) {
            throw new RequiredError("AccountsApi", "connectCustomerVaultAccount", "connectCustomerVaultAccountRequest");
        }
        const localVarPath = '/customer-vault-accounts';
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(connectCustomerVaultAccountRequest, "ConnectCustomerVaultAccountRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async connectGcpFolder(projectId, connectGcpFolderRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "connectGcpFolder", "projectId");
        }
        if (connectGcpFolderRequest === null || connectGcpFolderRequest === undefined) {
            throw new RequiredError("AccountsApi", "connectGcpFolder", "connectGcpFolderRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/gcp-folders'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(connectGcpFolderRequest, "ConnectGcpFolderRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async connectGcpOrganization(projectId, connectGcpOrganizationRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "connectGcpOrganization", "projectId");
        }
        if (connectGcpOrganizationRequest === null || connectGcpOrganizationRequest === undefined) {
            throw new RequiredError("AccountsApi", "connectGcpOrganization", "connectGcpOrganizationRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/gcp-organizations'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(connectGcpOrganizationRequest, "ConnectGcpOrganizationRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async connectGcpRestoreFolder(projectId, connectGcpFolderRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "connectGcpRestoreFolder", "projectId");
        }
        if (connectGcpFolderRequest === null || connectGcpFolderRequest === undefined) {
            throw new RequiredError("AccountsApi", "connectGcpRestoreFolder", "connectGcpFolderRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/gcp-restore-folders'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(connectGcpFolderRequest, "ConnectGcpFolderRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async connectGcpRestoreOrganization(projectId, connectGcpOrganizationRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "connectGcpRestoreOrganization", "projectId");
        }
        if (connectGcpOrganizationRequest === null || connectGcpOrganizationRequest === undefined) {
            throw new RequiredError("AccountsApi", "connectGcpRestoreOrganization", "connectGcpOrganizationRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/gcp-restore-organizations'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(connectGcpOrganizationRequest, "ConnectGcpOrganizationRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async connectRestoreAccount(projectId, connectRestoreAccountRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "connectRestoreAccount", "projectId");
        }
        if (connectRestoreAccountRequest === null || connectRestoreAccountRequest === undefined) {
            throw new RequiredError("AccountsApi", "connectRestoreAccount", "connectRestoreAccountRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/restore-accounts'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(connectRestoreAccountRequest, "ConnectRestoreAccountRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async connectRestoreAwsOrganizationalUnit(projectId, connectRestoreAwsOrganizationalUnitRequest, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "connectRestoreAwsOrganizationalUnit", "projectId");
        }
        if (connectRestoreAwsOrganizationalUnitRequest === null || connectRestoreAwsOrganizationalUnitRequest === undefined) {
            throw new RequiredError("AccountsApi", "connectRestoreAwsOrganizationalUnit", "connectRestoreAwsOrganizationalUnitRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/restore-aws-organizational-units'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(connectRestoreAwsOrganizationalUnitRequest, "ConnectRestoreAwsOrganizationalUnitRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async connectSourceAccount(projectId, connectSourceAccountRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "connectSourceAccount", "projectId");
        }
        if (connectSourceAccountRequest === null || connectSourceAccountRequest === undefined) {
            throw new RequiredError("AccountsApi", "connectSourceAccount", "connectSourceAccountRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/source-accounts'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(connectSourceAccountRequest, "ConnectSourceAccountRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async connectSourceAwsOrganizationalUnit(projectId, connectSourceAwsOrganizationalUnitRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "connectSourceAwsOrganizationalUnit", "projectId");
        }
        if (connectSourceAwsOrganizationalUnitRequest === null || connectSourceAwsOrganizationalUnitRequest === undefined) {
            throw new RequiredError("AccountsApi", "connectSourceAwsOrganizationalUnit", "connectSourceAwsOrganizationalUnitRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/source-aws-organizational-units'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(connectSourceAwsOrganizationalUnitRequest, "ConnectSourceAwsOrganizationalUnitRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async deactivateAtlasOrganization(projectId, id, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "deactivateAtlasOrganization", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("AccountsApi", "deactivateAtlasOrganization", "id");
        }
        const localVarPath = '/v1/projects/{projectId}/atlas-organizations/{id}/deactivate'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PATCH, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async deactivateAzureManagementGroup(projectId, id, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "deactivateAzureManagementGroup", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("AccountsApi", "deactivateAzureManagementGroup", "id");
        }
        const localVarPath = '/v1/projects/{projectId}/azure-management-groups/{id}/deactivate'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PATCH, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async deactivateGcpFolder(projectId, id, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "deactivateGcpFolder", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("AccountsApi", "deactivateGcpFolder", "id");
        }
        const localVarPath = '/v1/projects/{projectId}/gcp-folders/{id}/deactivate'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PATCH, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async deactivateGcpOrganization(projectId, id, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "deactivateGcpOrganization", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("AccountsApi", "deactivateGcpOrganization", "id");
        }
        const localVarPath = '/v1/projects/{projectId}/gcp-organizations/{id}/deactivate'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PATCH, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async deactivateGcpRestoreFolder(projectId, id, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "deactivateGcpRestoreFolder", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("AccountsApi", "deactivateGcpRestoreFolder", "id");
        }
        const localVarPath = '/v1/projects/{projectId}/gcp-restore-folders/{id}/deactivate'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PATCH, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async deactivateGcpRestoreOrganization(projectId, id, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "deactivateGcpRestoreOrganization", "projectId");
        }
        if (id === null || id === undefined) {
            throw new RequiredError("AccountsApi", "deactivateGcpRestoreOrganization", "id");
        }
        const localVarPath = '/v1/projects/{projectId}/gcp-restore-organizations/{id}/deactivate'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PATCH, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async deleteRestoreAccountConnectivityConfig(projectId, accountId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "deleteRestoreAccountConnectivityConfig", "projectId");
        }
        if (accountId === null || accountId === undefined) {
            throw new RequiredError("AccountsApi", "deleteRestoreAccountConnectivityConfig", "accountId");
        }
        const localVarPath = '/v1/projects/{projectId}/restore-accounts/{accountId}/connectivity-config'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.DELETE, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async deleteRestoreAccountV1(projectId, accountId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "deleteRestoreAccountV1", "projectId");
        }
        if (accountId === null || accountId === undefined) {
            throw new RequiredError("AccountsApi", "deleteRestoreAccountV1", "accountId");
        }
        const localVarPath = '/v1/projects/{projectId}/restore-accounts/{accountId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.DELETE, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async deleteSourceAccount(projectId, accountId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "deleteSourceAccount", "projectId");
        }
        if (accountId === null || accountId === undefined) {
            throw new RequiredError("AccountsApi", "deleteSourceAccount", "accountId");
        }
        const localVarPath = '/v1/projects/{projectId}/source-accounts/{accountId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.DELETE, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async disableRestoreAccountMetricsConfig(projectId, accountId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "disableRestoreAccountMetricsConfig", "projectId");
        }
        if (accountId === null || accountId === undefined) {
            throw new RequiredError("AccountsApi", "disableRestoreAccountMetricsConfig", "accountId");
        }
        const localVarPath = '/v1/projects/{projectId}/restore-accounts/{accountId}/metrics-config'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.DELETE, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async disableSourceAccountMetricsConfig(projectId, accountId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "disableSourceAccountMetricsConfig", "projectId");
        }
        if (accountId === null || accountId === undefined) {
            throw new RequiredError("AccountsApi", "disableSourceAccountMetricsConfig", "accountId");
        }
        const localVarPath = '/v1/projects/{projectId}/source-accounts/{accountId}/metrics-config'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.DELETE, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async disconnectCustomerVaultAccount(accountId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (accountId === null || accountId === undefined) {
            throw new RequiredError("AccountsApi", "disconnectCustomerVaultAccount", "accountId");
        }
        const localVarPath = '/vault-accounts/{accountId}/disconnect'
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async disconnectRestoreAccount(projectId, accountId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "disconnectRestoreAccount", "projectId");
        }
        if (accountId === null || accountId === undefined) {
            throw new RequiredError("AccountsApi", "disconnectRestoreAccount", "accountId");
        }
        const localVarPath = '/v1/projects/{projectId}/restore-accounts/{accountId}/disconnect'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async disconnectRestoreAwsOrganizationalUnit(projectId, organizationalUnitId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "disconnectRestoreAwsOrganizationalUnit", "projectId");
        }
        if (organizationalUnitId === null || organizationalUnitId === undefined) {
            throw new RequiredError("AccountsApi", "disconnectRestoreAwsOrganizationalUnit", "organizationalUnitId");
        }
        const localVarPath = '/v1/projects/{projectId}/restore-aws-organizational-units/{organizationalUnitId}/disconnect'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'organizationalUnitId' + '}', encodeURIComponent(String(organizationalUnitId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async disconnectSourceAccount(projectId, accountId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "disconnectSourceAccount", "projectId");
        }
        if (accountId === null || accountId === undefined) {
            throw new RequiredError("AccountsApi", "disconnectSourceAccount", "accountId");
        }
        const localVarPath = '/v1/projects/{projectId}/source-accounts/{accountId}/disconnect'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async disconnectSourceAwsOrganizationalUnit(projectId, organizationalUnitId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "disconnectSourceAwsOrganizationalUnit", "projectId");
        }
        if (organizationalUnitId === null || organizationalUnitId === undefined) {
            throw new RequiredError("AccountsApi", "disconnectSourceAwsOrganizationalUnit", "organizationalUnitId");
        }
        const localVarPath = '/v1/projects/{projectId}/source-aws-organizational-units/{organizationalUnitId}/disconnect'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'organizationalUnitId' + '}', encodeURIComponent(String(organizationalUnitId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async enableRestoreAccountMetricsConfig(projectId, accountId, enableRestoreAccountMetricsConfigRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "enableRestoreAccountMetricsConfig", "projectId");
        }
        if (accountId === null || accountId === undefined) {
            throw new RequiredError("AccountsApi", "enableRestoreAccountMetricsConfig", "accountId");
        }
        if (enableRestoreAccountMetricsConfigRequest === null || enableRestoreAccountMetricsConfigRequest === undefined) {
            throw new RequiredError("AccountsApi", "enableRestoreAccountMetricsConfig", "enableRestoreAccountMetricsConfigRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/restore-accounts/{accountId}/metrics-config'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PUT, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(enableRestoreAccountMetricsConfigRequest, "EnableRestoreAccountMetricsConfigRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async enableSourceAccountMetricsConfig(projectId, accountId, enableSourceAccountMetricsConfigRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "enableSourceAccountMetricsConfig", "projectId");
        }
        if (accountId === null || accountId === undefined) {
            throw new RequiredError("AccountsApi", "enableSourceAccountMetricsConfig", "accountId");
        }
        if (enableSourceAccountMetricsConfigRequest === null || enableSourceAccountMetricsConfigRequest === undefined) {
            throw new RequiredError("AccountsApi", "enableSourceAccountMetricsConfig", "enableSourceAccountMetricsConfigRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/source-accounts/{accountId}/metrics-config'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PUT, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(enableSourceAccountMetricsConfigRequest, "EnableSourceAccountMetricsConfigRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getAzureOnboardedTenants(projectId, requireInTenantDataAccessApp, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "getAzureOnboardedTenants", "projectId");
        }
        const localVarPath = '/projects/{projectId}/azure/onboarded-tenants'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (requireInTenantDataAccessApp !== undefined) {
            requestContext.setQueryParam("requireInTenantDataAccessApp", ObjectSerializer.serialize(requireInTenantDataAccessApp, "boolean", ""));
        }
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getEntraIdConnectionInfo(projectId, tenantId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "getEntraIdConnectionInfo", "projectId");
        }
        if (tenantId === null || tenantId === undefined) {
            throw new RequiredError("AccountsApi", "getEntraIdConnectionInfo", "tenantId");
        }
        const localVarPath = '/v1/projects/{projectId}/entra-id/{tenantId}/connection-info'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'tenantId' + '}', encodeURIComponent(String(tenantId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getGcsServiceAgent(accountId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (accountId === null || accountId === undefined) {
            throw new RequiredError("AccountsApi", "getGcsServiceAgent", "accountId");
        }
        const localVarPath = '/v1/scanning-accounts/{accountId}/gcs-service-agent'
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getGoogleWorkspaceConnectionInfo(projectId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "getGoogleWorkspaceConnectionInfo", "projectId");
        }
        const localVarPath = '/v1/projects/{projectId}/google-workspace/connection-info'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getGoogleWorkspaceRestoreConnectionInfo(projectId, gcpProjectId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "getGoogleWorkspaceRestoreConnectionInfo", "projectId");
        }
        if (gcpProjectId === null || gcpProjectId === undefined) {
            throw new RequiredError("AccountsApi", "getGoogleWorkspaceRestoreConnectionInfo", "gcpProjectId");
        }
        const localVarPath = '/v1/projects/{projectId}/google-workspace/restore-connection-info'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (gcpProjectId !== undefined) {
            requestContext.setQueryParam("gcpProjectId", ObjectSerializer.serialize(gcpProjectId, "string", "tobedefined"));
        }
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getMicrosoft365ConnectionInfo(projectId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "getMicrosoft365ConnectionInfo", "projectId");
        }
        const localVarPath = '/v1/projects/{projectId}/microsoft-365/connection-info'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getMicrosoft365RestoreConnectionInfo(projectId, tenantId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "getMicrosoft365RestoreConnectionInfo", "projectId");
        }
        if (tenantId === null || tenantId === undefined) {
            throw new RequiredError("AccountsApi", "getMicrosoft365RestoreConnectionInfo", "tenantId");
        }
        const localVarPath = '/v1/projects/{projectId}/microsoft-365/{tenantId}/restore-connection-info'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'tenantId' + '}', encodeURIComponent(String(tenantId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getRestoreAccount(projectId, accountId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "getRestoreAccount", "projectId");
        }
        if (accountId === null || accountId === undefined) {
            throw new RequiredError("AccountsApi", "getRestoreAccount", "accountId");
        }
        const localVarPath = '/v1/projects/{projectId}/restore-accounts/{accountId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getRestoreAccountCanDelete(projectId, accountId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "getRestoreAccountCanDelete", "projectId");
        }
        if (accountId === null || accountId === undefined) {
            throw new RequiredError("AccountsApi", "getRestoreAccountCanDelete", "accountId");
        }
        const localVarPath = '/v1/projects/{projectId}/restore-accounts/{accountId}/can-delete'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getRestoreAccountConnectivityConfig(projectId, accountId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "getRestoreAccountConnectivityConfig", "projectId");
        }
        if (accountId === null || accountId === undefined) {
            throw new RequiredError("AccountsApi", "getRestoreAccountConnectivityConfig", "accountId");
        }
        const localVarPath = '/v1/projects/{projectId}/restore-accounts/{accountId}/connectivity-config'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getRestoreAccountMetricsConfig(projectId, accountId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "getRestoreAccountMetricsConfig", "projectId");
        }
        if (accountId === null || accountId === undefined) {
            throw new RequiredError("AccountsApi", "getRestoreAccountMetricsConfig", "accountId");
        }
        const localVarPath = '/v1/projects/{projectId}/restore-accounts/{accountId}/metrics-config'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getSourceAccount(projectId, accountId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "getSourceAccount", "projectId");
        }
        if (accountId === null || accountId === undefined) {
            throw new RequiredError("AccountsApi", "getSourceAccount", "accountId");
        }
        const localVarPath = '/v1/projects/{projectId}/source-accounts/{accountId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getSourceAccountCanDelete(projectId, accountId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "getSourceAccountCanDelete", "projectId");
        }
        if (accountId === null || accountId === undefined) {
            throw new RequiredError("AccountsApi", "getSourceAccountCanDelete", "accountId");
        }
        const localVarPath = '/v1/projects/{projectId}/source-accounts/{accountId}/can-delete'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async getSourceAccountMetricsConfig(projectId, accountId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "getSourceAccountMetricsConfig", "projectId");
        }
        if (accountId === null || accountId === undefined) {
            throw new RequiredError("AccountsApi", "getSourceAccountMetricsConfig", "accountId");
        }
        const localVarPath = '/v1/projects/{projectId}/source-accounts/{accountId}/metrics-config'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listAtlasOrganizations(projectId, pageToken, pageSize, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "listAtlasOrganizations", "projectId");
        }
        const localVarPath = '/v1/projects/{projectId}/atlas-organizations'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (pageToken !== undefined) {
            requestContext.setQueryParam("pageToken", ObjectSerializer.serialize(pageToken, "string", "tobedefined"));
        }
        if (pageSize !== undefined) {
            requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
        }
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listAzureManagementGroups(projectId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "listAzureManagementGroups", "projectId");
        }
        const localVarPath = '/v1/projects/{projectId}/azure-management-groups'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listEksClusters(projectId, pageToken, pageSize, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "listEksClusters", "projectId");
        }
        const localVarPath = '/projects/{projectId}/eks-clusters'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (pageToken !== undefined) {
            requestContext.setQueryParam("pageToken", ObjectSerializer.serialize(pageToken, "string", "tobedefined"));
        }
        if (pageSize !== undefined) {
            requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
        }
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listGcpFolders(projectId, pageToken, pageSize, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "listGcpFolders", "projectId");
        }
        const localVarPath = '/v1/projects/{projectId}/gcp-folders'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (pageToken !== undefined) {
            requestContext.setQueryParam("pageToken", ObjectSerializer.serialize(pageToken, "string", "tobedefined"));
        }
        if (pageSize !== undefined) {
            requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
        }
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listGcpOrganizations(projectId, pageToken, pageSize, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "listGcpOrganizations", "projectId");
        }
        const localVarPath = '/v1/projects/{projectId}/gcp-organizations'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (pageToken !== undefined) {
            requestContext.setQueryParam("pageToken", ObjectSerializer.serialize(pageToken, "string", "tobedefined"));
        }
        if (pageSize !== undefined) {
            requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
        }
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listGcpRestoreFolders(projectId, pageToken, pageSize, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "listGcpRestoreFolders", "projectId");
        }
        const localVarPath = '/v1/projects/{projectId}/gcp-restore-folders'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (pageToken !== undefined) {
            requestContext.setQueryParam("pageToken", ObjectSerializer.serialize(pageToken, "string", "tobedefined"));
        }
        if (pageSize !== undefined) {
            requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
        }
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listGcpRestoreOrganizations(projectId, pageToken, pageSize, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "listGcpRestoreOrganizations", "projectId");
        }
        const localVarPath = '/v1/projects/{projectId}/gcp-restore-organizations'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.GET, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (pageToken !== undefined) {
            requestContext.setQueryParam("pageToken", ObjectSerializer.serialize(pageToken, "string", "tobedefined"));
        }
        if (pageSize !== undefined) {
            requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
        }
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listRestoreAccounts(projectId, pageToken, pageSize, listRestoreAccountsRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "listRestoreAccounts", "projectId");
        }
        const localVarPath = '/v1/projects/{projectId}/restore-accounts/list'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (pageToken !== undefined) {
            requestContext.setQueryParam("pageToken", ObjectSerializer.serialize(pageToken, "string", "tobedefined"));
        }
        if (pageSize !== undefined) {
            requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(listRestoreAccountsRequest, "ListRestoreAccountsRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listRestoreAwsOrganizationalUnits(projectId, pageToken, pageSize, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "listRestoreAwsOrganizationalUnits", "projectId");
        }
        const localVarPath = '/v1/projects/{projectId}/restore-aws-organizational-units/list'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (pageToken !== undefined) {
            requestContext.setQueryParam("pageToken", ObjectSerializer.serialize(pageToken, "string", "tobedefined"));
        }
        if (pageSize !== undefined) {
            requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
        }
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listSourceAccounts(projectId, pageToken, pageSize, listSourceAccountsRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "listSourceAccounts", "projectId");
        }
        const localVarPath = '/v1/projects/{projectId}/source-accounts/list'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (pageToken !== undefined) {
            requestContext.setQueryParam("pageToken", ObjectSerializer.serialize(pageToken, "string", "tobedefined"));
        }
        if (pageSize !== undefined) {
            requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
        }
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(listSourceAccountsRequest, "ListSourceAccountsRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async listSourceAwsOrganizationalUnits(projectId, pageToken, pageSize, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "listSourceAwsOrganizationalUnits", "projectId");
        }
        const localVarPath = '/v1/projects/{projectId}/source-aws-organizational-units/list'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (pageToken !== undefined) {
            requestContext.setQueryParam("pageToken", ObjectSerializer.serialize(pageToken, "string", "tobedefined"));
        }
        if (pageSize !== undefined) {
            requestContext.setQueryParam("pageSize", ObjectSerializer.serialize(pageSize, "number", ""));
        }
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async reconnectCustomerVaultAccount(accountId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (accountId === null || accountId === undefined) {
            throw new RequiredError("AccountsApi", "reconnectCustomerVaultAccount", "accountId");
        }
        const localVarPath = '/vault-accounts/{accountId}/reconnect'
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async reconnectRestoreAccount(projectId, accountId, xActionApprovalRequestId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "reconnectRestoreAccount", "projectId");
        }
        if (accountId === null || accountId === undefined) {
            throw new RequiredError("AccountsApi", "reconnectRestoreAccount", "accountId");
        }
        const localVarPath = '/v1/projects/{projectId}/restore-accounts/{accountId}/reconnect'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        if (xActionApprovalRequestId !== undefined) {
            requestContext.setHeaderParam("X-Action-Approval-Request-Id", ObjectSerializer.serialize(xActionApprovalRequestId, "string", "uuid"));
        }
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async reconnectRestoreAwsOrganizationalUnit(projectId, organizationalUnitId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "reconnectRestoreAwsOrganizationalUnit", "projectId");
        }
        if (organizationalUnitId === null || organizationalUnitId === undefined) {
            throw new RequiredError("AccountsApi", "reconnectRestoreAwsOrganizationalUnit", "organizationalUnitId");
        }
        const localVarPath = '/v1/projects/{projectId}/restore-aws-organizational-units/{organizationalUnitId}/reconnect'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'organizationalUnitId' + '}', encodeURIComponent(String(organizationalUnitId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async reconnectSourceAccount(projectId, accountId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "reconnectSourceAccount", "projectId");
        }
        if (accountId === null || accountId === undefined) {
            throw new RequiredError("AccountsApi", "reconnectSourceAccount", "accountId");
        }
        const localVarPath = '/v1/projects/{projectId}/source-accounts/{accountId}/reconnect'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async reconnectSourceAwsOrganizationalUnit(projectId, organizationalUnitId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "reconnectSourceAwsOrganizationalUnit", "projectId");
        }
        if (organizationalUnitId === null || organizationalUnitId === undefined) {
            throw new RequiredError("AccountsApi", "reconnectSourceAwsOrganizationalUnit", "organizationalUnitId");
        }
        const localVarPath = '/v1/projects/{projectId}/source-aws-organizational-units/{organizationalUnitId}/reconnect'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'organizationalUnitId' + '}', encodeURIComponent(String(organizationalUnitId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async syncRestoreAccountPermissions(projectId, accountId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "syncRestoreAccountPermissions", "projectId");
        }
        if (accountId === null || accountId === undefined) {
            throw new RequiredError("AccountsApi", "syncRestoreAccountPermissions", "accountId");
        }
        const localVarPath = '/projects/{projectId}/restore-accounts/{accountId}/check-permissions'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async syncSourceAccountPermissions(projectId, accountId, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "syncSourceAccountPermissions", "projectId");
        }
        if (accountId === null || accountId === undefined) {
            throw new RequiredError("AccountsApi", "syncSourceAccountPermissions", "accountId");
        }
        const localVarPath = '/projects/{projectId}/source-accounts/{accountId}/check-permissions'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.POST, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async updateRestoreAccount(projectId, accountId, updateRestoreAccountRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "updateRestoreAccount", "projectId");
        }
        if (accountId === null || accountId === undefined) {
            throw new RequiredError("AccountsApi", "updateRestoreAccount", "accountId");
        }
        if (updateRestoreAccountRequest === null || updateRestoreAccountRequest === undefined) {
            throw new RequiredError("AccountsApi", "updateRestoreAccount", "updateRestoreAccountRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/restore-accounts/{accountId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PATCH, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(updateRestoreAccountRequest, "UpdateRestoreAccountRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async updateRestoreAccountConnectivityConfig(projectId, accountId, updateRestoreAccountConnectivityConfigRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "updateRestoreAccountConnectivityConfig", "projectId");
        }
        if (accountId === null || accountId === undefined) {
            throw new RequiredError("AccountsApi", "updateRestoreAccountConnectivityConfig", "accountId");
        }
        if (updateRestoreAccountConnectivityConfigRequest === null || updateRestoreAccountConnectivityConfigRequest === undefined) {
            throw new RequiredError("AccountsApi", "updateRestoreAccountConnectivityConfig", "updateRestoreAccountConnectivityConfigRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/restore-accounts/{accountId}/connectivity-config'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PUT, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(updateRestoreAccountConnectivityConfigRequest, "UpdateRestoreAccountConnectivityConfigRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
    async updateSourceAccount(projectId, accountId, updateSourceAccountRequest, _options) {
        let _config;
        if (!_options) {
            _config = this.configuration;
        }
        else {
            _config = Object.assign({}, _options, this.configuration);
        }
        if (projectId === null || projectId === undefined) {
            throw new RequiredError("AccountsApi", "updateSourceAccount", "projectId");
        }
        if (accountId === null || accountId === undefined) {
            throw new RequiredError("AccountsApi", "updateSourceAccount", "accountId");
        }
        if (updateSourceAccountRequest === null || updateSourceAccountRequest === undefined) {
            throw new RequiredError("AccountsApi", "updateSourceAccount", "updateSourceAccountRequest");
        }
        const localVarPath = '/v1/projects/{projectId}/source-accounts/{accountId}'
            .replace('{' + 'projectId' + '}', encodeURIComponent(String(projectId)))
            .replace('{' + 'accountId' + '}', encodeURIComponent(String(accountId)));
        let signal = _config.timeout ? AbortSignal.timeout(_config.timeout) : undefined;
        const requestContext = _config.baseServer.makeRequestContext(localVarPath, HttpMethod.PATCH, signal);
        requestContext.setHeaderParam("Accept", "application/json, */*;q=0.8");
        const contentType = "application/json";
        requestContext.setHeaderParam("Content-Type", contentType);
        const serializedBody = JSON.stringify(ObjectSerializer.serialize(updateSourceAccountRequest, "UpdateSourceAccountRequest", ""));
        requestContext.setBody(serializedBody);
        let authMethod;
        authMethod = _config.authMethods["ApiKeyAuth"];
        if (authMethod?.applySecurityAuthentication) {
            await authMethod?.applySecurityAuthentication(requestContext);
        }
        return requestContext;
    }
}
export class AccountsApiResponseProcessor {
    async activateAtlasOrganizationWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ActivateAtlasOrganizationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async activateAzureManagementGroupWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "AzureManagementGroup", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async activateGcpFolderWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ActivateGcpFolderResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async activateGcpOrganizationWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ActivateGcpOrganizationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async activateGcpRestoreFolderWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ActivateGcpFolderResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async activateGcpRestoreOrganizationWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ActivateGcpOrganizationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async connectAtlasOrganizationWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ConnectAtlasOrganizationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Atlas organization already exists in Eon.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async connectCustomerVaultAccountWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ConnectCustomerVaultAccountResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Customer-owned vault account already exists in Eon.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async connectGcpFolderWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ConnectGcpFolderResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Gcp folder already exists in Eon.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async connectGcpOrganizationWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ConnectGcpOrganizationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Gcp organization already exists in Eon.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async connectGcpRestoreFolderWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ConnectGcpFolderResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "MPAInterceptedResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Gcp restore folder already exists in Eon.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async connectGcpRestoreOrganizationWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ConnectGcpOrganizationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "MPAInterceptedResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Gcp restore organization already exists in Eon.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async connectRestoreAccountWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ConnectRestoreAccountResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "MPAInterceptedResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Restore account already connected to the project.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async connectRestoreAwsOrganizationalUnitWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ConnectRestoreAwsOrganizationalUnitResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "MPAInterceptedResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "AWS organizational unit already exists in Eon.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async connectSourceAccountWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ConnectSourceAccountResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Source account already exists in Eon.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async connectSourceAwsOrganizationalUnitWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ConnectSourceAwsOrganizationalUnitResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "AWS organizational unit already exists in Eon.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async deactivateAtlasOrganizationWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "DeactivateAtlasOrganizationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async deactivateAzureManagementGroupWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "AzureManagementGroup", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async deactivateGcpFolderWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "DeactivateGcpFolderResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async deactivateGcpOrganizationWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "DeactivateGcpOrganizationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async deactivateGcpRestoreFolderWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "DeactivateGcpFolderResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async deactivateGcpRestoreOrganizationWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "DeactivateGcpOrganizationResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async deleteRestoreAccountConnectivityConfigWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, undefined);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Restore account not found.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async deleteRestoreAccountV1WithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, undefined);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Restore account wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Restore account is connected and can\&#39;t be deleted.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async deleteSourceAccountWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, undefined);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Source account wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Source account is connected and can\&#39;t be deleted.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async disableRestoreAccountMetricsConfigWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, undefined);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Restore account wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async disableSourceAccountMetricsConfigWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, undefined);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Source account wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async disconnectCustomerVaultAccountWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "DisconnectCustomerVaultAccountResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async disconnectRestoreAccountWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "DisconnectRestoreAccountResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async disconnectRestoreAwsOrganizationalUnitWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "DisconnectRestoreAwsOrganizationalUnitResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async disconnectSourceAccountWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "DisconnectSourceAccountResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async disconnectSourceAwsOrganizationalUnitWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "DisconnectSourceAwsOrganizationalUnitResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async enableRestoreAccountMetricsConfigWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "EnableRestoreAccountMetricsConfigResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Restore account wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async enableSourceAccountMetricsConfigWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "EnableSourceAccountMetricsConfigResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Source account wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getAzureOnboardedTenantsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "AzureOnboardedTenantsResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Bad request - Invalid project ID", undefined, response.headers, response);
        }
        if (isCodeInRange("401", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Unauthorized", undefined, response.headers, response);
        }
        if (isCodeInRange("500", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Internal server error", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getEntraIdConnectionInfoWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "EntraIdConnectionInfo", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("403", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Entra ID onboarding is not enabled for this project.", undefined, response.headers, response);
        }
        if (isCodeInRange("503", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Entra ID application is still being provisioned. Retry shortly.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getGcsServiceAgentWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "GetGcsServiceAgentResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Invalid request (e.g., account is not a GCP scanning account).", undefined, response.headers, response);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Scanning account not found.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getGoogleWorkspaceConnectionInfoWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "GoogleWorkspaceConnectionInfo", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("403", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Google Workspace onboarding is not enabled for this project.", undefined, response.headers, response);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "No GCP scanning account exists for this eon account. Onboard GCP before Google Workspace.", undefined, response.headers, response);
        }
        if (isCodeInRange("503", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Google Workspace service accounts are still being provisioned. Retry shortly.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getGoogleWorkspaceRestoreConnectionInfoWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "GoogleWorkspaceServiceAccountInfo", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("403", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Google Workspace onboarding is not enabled for this project.", undefined, response.headers, response);
        }
        if (isCodeInRange("503", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Google Workspace restore service account is still being provisioned. Retry shortly.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getMicrosoft365ConnectionInfoWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "Microsoft365ConnectionInfo", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("403", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Microsoft 365 onboarding is not enabled for this project.", undefined, response.headers, response);
        }
        if (isCodeInRange("503", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Microsoft 365 application is still being provisioned. Retry shortly.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getMicrosoft365RestoreConnectionInfoWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "Microsoft365ConnectionInfo", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("403", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Microsoft 365 onboarding is not enabled for this project.", undefined, response.headers, response);
        }
        if (isCodeInRange("503", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Microsoft 365 application is still being provisioned. Retry shortly.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getRestoreAccountWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "GetRestoreAccountResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Restore account wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getRestoreAccountCanDeleteWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "GetRestoreAccountCanDelete200Response", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Restore account wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getRestoreAccountConnectivityConfigWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "GetRestoreAccountConnectivityConfigResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Restore account not found.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getRestoreAccountMetricsConfigWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "GetRestoreAccountMetricsConfigResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Restore account wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getSourceAccountWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "GetSourceAccountResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Source account wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getSourceAccountCanDeleteWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "GetSourceAccountCanDelete200Response", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Source account wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async getSourceAccountMetricsConfigWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "GetSourceAccountMetricsConfigResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Source account wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listAtlasOrganizationsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ListAtlasOrganizationsResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listAzureManagementGroupsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "AzureManagementGroups", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listEksClustersWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ListEksClustersResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listGcpFoldersWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ListGcpFoldersResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listGcpOrganizationsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ListGcpOrganizationsResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listGcpRestoreFoldersWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ListGcpFoldersResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listGcpRestoreOrganizationsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ListGcpOrganizationsResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listRestoreAccountsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ListRestoreAccountsResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listRestoreAwsOrganizationalUnitsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ListRestoreAwsOrganizationalUnitsResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listSourceAccountsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ListSourceAccountsResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async listSourceAwsOrganizationalUnitsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ListSourceAwsOrganizationalUnitsResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async reconnectCustomerVaultAccountWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ReconnectCustomerVaultAccountResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async reconnectRestoreAccountWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ReconnectRestoreAccountResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("201", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "MPAInterceptedResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("409", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "The action approval request id in X-Action-Approval-Request-Id is not in APPROVED status, has already been executed, has expired, or its captured method/path/body no longer matches the incoming request. ", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async reconnectRestoreAwsOrganizationalUnitWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ReconnectRestoreAwsOrganizationalUnitResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async reconnectSourceAccountWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ReconnectSourceAccountResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async reconnectSourceAwsOrganizationalUnitWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "ReconnectSourceAwsOrganizationalUnitResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async syncRestoreAccountPermissionsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "RestoreAccount", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async syncSourceAccountPermissionsWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "SourceAccount", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async updateRestoreAccountWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "UpdateRestoreAccountResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Invalid request. Typically this indicates invalid JSON, invalid or changed restore account ID, or the cloud provider did not accept verification of the updated role or service account. ", undefined, response.headers, response);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Restore account wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async updateRestoreAccountConnectivityConfigWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "UpdateRestoreAccountConnectivityConfigResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Restore account not found.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
    async updateSourceAccountWithHttpInfo(response) {
        if (isCodeInRange("200", response.httpStatusCode)) {
            const body = await deserializeResponseBody(response, "UpdateSourceAccountResponse", "");
            return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
        }
        if (isCodeInRange("400", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Invalid request. Typically this indicates invalid JSON, invalid or changed source account ID, or the cloud provider did not accept verification of the updated role or service account. ", undefined, response.headers, response);
        }
        if (isCodeInRange("404", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Source account wasn\&#39;t found.", undefined, response.headers, response);
        }
        if (isCodeInRange("1XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Informational", undefined, response.headers, response);
        }
        if (isCodeInRange("3XX", response.httpStatusCode)) {
            throw new ApiException(response.httpStatusCode, "Redirect", undefined, response.headers, response);
        }
        if (isCodeInRange("4XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Client Error", body, response.headers, response);
        }
        if (isCodeInRange("5XX", response.httpStatusCode)) {
            const body = await deserializeErrorBodyOrFallback(response, "Error", "");
            throw new ApiException(response.httpStatusCode, "Internal Server Error", body, response.headers, response);
        }
        if (response.httpStatusCode < 200 || response.httpStatusCode > 299) {
            throw new ApiException(response.httpStatusCode, "Unknown API Status Code!", await response.getBodyAsAny(), response.headers, response);
        }
        const body = await response.body.json();
        return new HttpInfo(response.httpStatusCode, response.headers, response.body, body);
    }
}
